const destinations = [
  {
    name: "Jerusalem & Israel",
    context: "The OU Jerusalem Center sends hundreds of students per semester. Israel requires 6-month valid passport and may require biometric data.",
    urgency: "OU Jerusalem Center sends students in July and December — the two busiest Norman passport rushes",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "United Kingdom",
    context: "OU students frequently study in London through exchange programs. Business travelers from Norman's tech corridor also visit regularly.",
    urgency: "Corporate and student travel has 7–14 day lead time in many cases",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Rome & Italy",
    context: "Popular study abroad destination for OU arts and humanities students. Many Norman churches also organize Italian pilgrimage tours.",
    urgency: "Study-abroad deadlines create predictable October and February passport rush seasons",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Mexico & Caribbean",
    context: "Short-term mission trips and family vacations. Norman residents can fly direct from OKC to Cancun in under 3 hours.",
    urgency: "Last-minute Cancun charters and cruise bookings peak March through August",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "South Korea",
    context: "Norman has a growing Korean community and OU has academic exchange programs with Korean universities. Visa-free for U.S. citizens up to 90 days.",
    urgency: "Exchange program deadlines create predictable passport demand twice per year",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Australia",
    context: "Popular destination for OU study abroad and research programs. 6-month validity required. eTA required for U.S. citizens.",
    urgency: "Summer research programs create demand in March through May",
    icon: "ri-map-pin-2-line",
  },
];

const commonSituations = [
  {
    stat: "~2,800",
    label: "OU students study abroad each year, creating predictable peak passport demand",
  },
  {
    stat: "2–4 Weeks",
    label: "average notice OU students have before discovering a passport issue before semester abroad",
  },
  {
    stat: "Aug / Dec",
    label: "peak seasons when Jerusalem Center, spring abroad, and holiday travel collide",
  },
  {
    stat: "72 Hours",
    label: "shortest OU Health physician turnaround we have accommodated for a WHO conference",
  },
];

export default function NormanDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Norman Residents Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Cleveland County clients. Understanding local travel behavior is part of why our document review catches issues before they derail your study abroad, medical conference, or family vacation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {commonSituations.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Oklahoma Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Oklahoma with the same expedited passport processing and document review expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/oklahoma-city" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Oklahoma City <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/tulsa" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Tulsa <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/broken-arrow" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Broken Arrow <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}